/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'feedback-collector.anonymous': 'ข้อคิดเห็นนี้กำลังถูกส่งโดยไม่ระบุชื่อ Atlassian จะไม่สามารถติดต่อคุณได้โดยตรงเกี่ยวกับข้อคิดเห็นนี้',
  'feedback-collector.anonymous.title': 'ข้อคิดเห็นจากผู้ที่ไม่ระบุตัวตน',
  'feedback-collector.can-be-contacted.label': 'ใช่ ทีม Atlassian สามารถติดต่อฉันเพื่อเรียนรู้เกี่ยวกับประสบการณ์ของฉันเพื่อปรับปรุงผลิตภัณฑ์และบริการของ Atlassian ได้ ฉันรับทราบ <a>นโยบายความเป็นส่วนตัวของ Atlassian</a> แล้ว',
  'feedback-collector.cancel-button.label': 'ยกเลิก',
  'feedback-collector.default.custom.textarea.label': 'คุณคิดอะไรอยู่',
  'feedback-collector.enrol-in-research.label': 'ฉันต้องการเข้าร่วมการวิจัยผลิตภัณฑ์',
  'feedback-collector.feedback-title': 'แบ่งปันความคิดเห็นของคุณ',
  'feedback-collector.form.bug.label': 'อธิบายข้อผิดพลาดหรือปัญหา',
  'feedback-collector.form.comment.label': 'แจ้งให้เราทราบถึงสิ่งที่คุณคิด',
  'feedback-collector.form.empty.label': 'เลือกตัวเลือก',
  'feedback-collector.form.question.label': 'คุณต้องการรู้อะไรบ้าง',
  'feedback-collector.form.suggestion.label': 'บอกให้เรารู้ว่าคุณต้องการปรับปรุงสิ่งใด',
  'feedback-collector.option.bug.label': 'รายงานข้อผิดพลาด',
  'feedback-collector.option.comment.label': 'แสดงความคิดเห็น',
  'feedback-collector.option.default.label': 'เลือกข้อคิดเห็น',
  'feedback-collector.option.default.placeholder': 'เลือกหนึ่งรายการ',
  'feedback-collector.option.question.label': 'ถามคำถาม',
  'feedback-collector.option.suggestion.label': 'แนะนำการปรับปรุง',
  'feedback-collector.required.fields.summary': 'ช่องที่จำเป็นต้องระบุจะมีเครื่องหมายดอกจัน',
  'feedback-collector.submit-button.label': 'ส่งข้อเสนอแนะ',
  'feedback-collector.success-flag.description': 'คำติชมอันมีค่าของคุณจะช่วยให้เราปรับปรุงผลิตภัณฑ์ของเราได้อย่างต่อเนื่อง',
  'feedback-collector.success-flag.title': 'ขอบคุณ',
  'feedback-collector.summary-placeholder': 'แจ้งให้เราทราบถึงสิ่งที่คุณคิด',
  'proforma-form-builder.feedback-icon-label': 'ข้อคิดเห็น',
  'proforma-form-builder.give-feedback': 'ให้ข้อคิดเห็น'
};